<div class="cpp-layout {{layoutClass}}" [ngClass]="{'_is-hidden': !this.visible}">
  <div class="cpp-layout__canvas" #canvas>
    <u4-cpp-header (loaded)="componentLoaded('header')"></u4-cpp-header>
    <u4-cpp-notificationbar></u4-cpp-notificationbar>
    <div class="cpp-layout__canvas-content">
      <router-outlet></router-outlet>
    </div>
    <u4-cpp-footer (loaded)="componentLoaded('footer')"></u4-cpp-footer>
  </div>
</div>

<u4-cpp-modal></u4-cpp-modal>
